<template>
    <div id="cautionview">
        <div class="row font-size-14">
            <div class="col-12 comment">
                <span v-html="caution"></span>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import Common from '../common'
export default defineComponent({
    data() {
        return ({
            key: "/contents/TopCaution1.html",
            caution: ""
        })
    },
    created: function () {
        this.loadHtml()
    },
    methods: {
        loadHtml: function () {
            fetch(this.key).then((res) => {
                res.text().then((html) => {
                    // マークダウン形式のアコーディオンをHTMLに変換してから表示
                    this.caution = Common.convertAccordionTags(html);
                });
            });
        },
    },
})
</script>

<style>
.info-item {
    margin-bottom: 10px;
    border-bottom: 1px solid rgb(240, 239, 239);
}

.font-size-14 {
    font-size: 14px !important;
}
</style>
